import React from 'react';
import Csc from '../Csc';
type Props = {};

const CscContainer = (props: Props) => {
  return <Csc />;
};

export default CscContainer;
